import { render, staticRenderFns } from "./publishArticle.vue?vue&type=template&id=461f7942&"
import script from "./publishArticle.vue?vue&type=script&lang=js&"
export * from "./publishArticle.vue?vue&type=script&lang=js&"
import style0 from "./publishArticle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports